import React, { useContext, useState } from 'react';
import { useFormik } from "formik";
import { perkPriceLimitFormValidationSchema } from "../../utilities/Validations";
import axios from "axios";
import { AppContext } from "../../context/app/appContext";

export const Perk = ({ id, providerName, icon, price, editablePrice, status, approved, onApprove, onRemove, onUpdate, programId }) => {

    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    const accessToken = localStorage.getItem('accessToken');
    let API = axios.create({ baseURL, headers: { 'Authorization': `Bearer ${accessToken}` }, });

    const appContext = useContext(AppContext);

    const [showEditPriceForm, setShowEditPriceForm] = useState(false);

    const limitPriceForm = useFormik({
        initialValues: {
            perkPriceLimit: price,
        },
        validationSchema: perkPriceLimitFormValidationSchema,
        onSubmit: async values => {
            console.info({ perkPriceLimit: values.perkPriceLimit });

            appContext.setLoading();
            const response = await API.post(`/perks-program/perk/set-price-limit`,
                {
                    programId: programId,
                    perkId: id,
                    priceLimit: values.perkPriceLimit,
                }).catch(error => {
                    console.info({ error });
                    if (error.isAxiosError && error.response.data && error.response.data.status) {
                        console.info(error.response.data.status);
                        const { code, message } = error.response.data.status;
                        console.info({ code, message });
                        appContext.setLoading(false);
                        return error.response.data.status;
                    } else {
                        appContext.setLoading(false);
                    }
                });
            if (response && response.data && response.data.status) {
                const { code, message } = response.data.status;
                console.info({ code, message });
                if (code === `perkProgram/perk-price-limit-updated`) onUpdate({ id: id, price: values.perkPriceLimit, name: providerName, icon });
                appContext.setLoading(false);
                //limitPriceForm.resetForm();
                setShowEditPriceForm(false);
            }
        }
    });

    const handleCancelEditPrice = () => {
        limitPriceForm.resetForm();
        setShowEditPriceForm(false);
    }

    const handleApproveRemove = (approvedPerk) => {
        if (approvedPerk) {
            onRemove(id, providerName);
            // await axios.post('http://localhost:8080/slack/message', {email: "abelp915@gmail.com", message: "A perk has been removed from your perk program"})
        } else {
            onApprove({ id, price, providerName, iconURL })
        }
    }

    /*const actionButton =
        (<Fragment>
            <div className={`ui button ${actionButtonClass}`}>{actionButtonLabel}</div>
            {status === 'pending-deactivation' &&
            (<h6>Will be removed by 20-12-2020</h6>)}
        </Fragment>);*/

    const editablePriceForm = <>
        <div className="ui error field">
            <div className="middle-centered">$</div>
            <div className="ui input">
                <input type="number" min="0" max="300" name="perkPriceLimit" id="perkPriceLimit" value={limitPriceForm.values.perkPriceLimit} onChange={limitPriceForm.handleChange}
                    // <input type="number" min="0" max="300" name="perkPriceLimit" id="perkPriceLimit" value={price} onChange={limitPriceForm.handleChange}
                    onBlur={limitPriceForm.handleBlur} />
            </div>
            <div className="ui item list">
                <div className="item">
                    <button disabled={!limitPriceForm.isValid || limitPriceForm.values === limitPriceForm.initialValues} onClick={limitPriceForm.submitForm}>Save</button>
                </div>
                <div className="item">
                    <button onClick={handleCancelEditPrice}>Cancel</button>
                </div>
            </div>
            {limitPriceForm.errors.perkPriceLimit && limitPriceForm.touched.perkPriceLimit ? (
                <div className="error-message" role="alert" aria-atomic="true">{limitPriceForm.errors.perkPriceLimit}</div>) : ''}
        </div>
    </>;

    // const iconURL = `${process.env.PUBLIC_URL}/assets/images/perks/${icon}.png`;
    const iconURL = `https://s3.us-east-2.amazonaws.com/client.staging.perkfix.com/assets/images/perks/${icon}.png`;
    return (
        <tr className="perk-item" style={{ backgroundColor: 'rgba(238, 241, 243, 1)' }}>
            <td className="perk-provider" style={{ height: 82 }}><img src={iconURL} alt={providerName} className="ui image middle aligned" style={{ maxHeight: 60 }} /><span>{providerName}</span>
            </td>
            <td style={{ height: 82 }}>
                {(editablePrice && showEditPriceForm) && editablePriceForm}
                {(editablePrice && !showEditPriceForm) && (<>${price}
                    <button disabled={!approved} onClick={e => setShowEditPriceForm(true)}>Edit</button>
                </>)}
                {!editablePrice && (<>${price}</>)}
            </td>
            <td className="right aligned" style={{ height: 82 }}>
                <button className="ui button" onClick={e => handleApproveRemove(approved)}>{approved ? 'Remove' : 'Approve'}</button>
            </td>
        </tr>
    );
};
